import React, { useRef } from "react";
import HomeBanner from "./components/HomeBanner";
import CarValuePromotion from "./components/CarValuePromotion";
import LoanComparisonBanner from "./components/LoanComparisonBanner";
import LoanProductGrid from "./components/LoanProductGrid";
import LoanProductInfo from "./components/LoanProductInfo";
import LoanCalculator from "./components/LoanCalculator";
import HomeCsBanner from "./components/HomeCsBanner";
import CustomerForm from "./components/CustomerForm";
import HomeCsTel from "./components/HomeCsTel";
import Alert from "./components/Alert";
import Footer from "./components/Footer";

function App() {
	const formRef = useRef(null);
	return (
		<main
			className='main-page'
			style={{
				fontFamily: "Spoqa Han Sans Neo, sans-serif",
				overflowX: "hidden",
			}}
		>
			<HomeBanner scrollToForm={() => formRef.current?.scrollToForm()} />
			<CarValuePromotion />
			<LoanComparisonBanner />
			<LoanProductGrid />
			<LoanProductInfo />
			<LoanCalculator />
			<HomeCsBanner scrollToForm={() => formRef.current?.scrollToForm()} />
			<CustomerForm ref={formRef} />
			<HomeCsTel />
			<Alert />
			<Footer />
		</main>
	);
}

export default App;
